import { MedplumClient } from "@medplum/core";
import { DocumentReference } from "@medplum/fhirtypes";

import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { deleteFile as apiDeleteFile } from "@/utils/uploads";

import { RootState } from "..";

const eduResourcesAdapter = createEntityAdapter({
  selectId: (eduResource: DocumentReference) => eduResource.id!,
});

export const deleteEduResourceThunk = createAsyncThunk(
  "eduResources/delete",
  async (
    {
      medplum,
      eduResourceFile,
    }: {
      medplum: MedplumClient;
      eduResourceFile: DocumentReference;
    },
    { dispatch },
  ) => {
    await apiDeleteFile(medplum, eduResourceFile);
    if (eduResourceFile.id) {
      dispatch(removeEduResource(eduResourceFile.id));
    }
  },
);

const reducers = {
  loadEduResources: eduResourcesAdapter.setAll,
  upsertEduResource: eduResourcesAdapter.upsertOne,
  removeEduResource: eduResourcesAdapter.removeOne,
};

export const eduResourcesSlice = createSlice({
  name: "eduResources",
  initialState: eduResourcesAdapter.getInitialState(),
  reducers,
});

export const { loadEduResources, upsertEduResource, removeEduResource } = eduResourcesSlice.actions;

export const selectEduResources = (state: RootState) => state.eduResources.entities;

export const selectEduResourcesList = (state: RootState) =>
  Object.values(state.eduResources.entities);

export default eduResourcesSlice.reducer;
